import Vue from 'vue'
import VueRouter from 'vue-router'

import Reports from '@/views/Reports.vue'
import RecruiterFees from '@/views/RecruiterFees.vue'
import RecruiterReport from '@/views/RecruiterReport.vue'
import RecruiterPayments from '@/views/RecruiterPayments.vue'
import Stats from '@/views/Stats.vue'
import Companies from '@/views/Companies.vue'
import Offers from '@/views/Offers.vue'
import Login from '@/views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'offers',
    component: Offers
  },
  {
    path: '/reports',
    name: 'reports',
    component: Reports
  },
  {
    path: '/companies',
    name: 'companies',
    component: Companies
  },
  {
    path: '/recruiter-fees',
    name: 'recruiter_fees',
    component: RecruiterFees
  },
  {
    path: '/recruiter-report',
    name: 'recruiter_report',
    component: RecruiterReport
  },
  {
    path: '/recruiter-payments',
    name: 'recruiter_payments',
    component: RecruiterPayments
  },
  {
    path: '/stats',
    name: 'stats',
    component: Stats
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { authPath: true },
    beforeEnter: (to, from, next) => {
      if (router.app.$utils.isLoggedIn()) {
        next({ name: '' })
      } else {
        next()
      }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Global Before Guards
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authPath)) {
    next()
  } else {
    if (router.app.$utils.isLoggedIn()) {
      next()
    } else {
      next({ name: 'login' })
    }
  }
})

export default router
